<template>
  <div class="iv-commont-title iv-p-t-8 iv-p-b-12">
    <span class="iconbox iv-m-r-12">
      <IconFont :type="icon" v-if="icon" class="iv-fs-20"></IconFont>
    </span>
    <span class="iv-main-text">
      <span class="iv-main-color iv-main-title iv-fw-b iv-m-r-4" v-if="main">{{ main }}</span>
      <span class="iv-main-color iv-fc-85 iv-fs-24" v-if="text">{{ text }}</span>
    </span>
    <span class="iv-more-box iv-pointer iv-fs-14 iv-fc-65 iv-p-t-12" v-if="showMore" @click="onMoreClick">{{ moreText }}
      <span class="iv-m-l-8">
        <IconFont :type="iconMore || 'gengduo'" class="iv-fs-12 iv-fc-65"></IconFont>
      </span>
    </span>
  </div>
</template>
<script>
import IconFont from '@/components/iconfont'
export default {
  components: { IconFont },
  props: {
    icon: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    main: {
      type: String,
      default: ''
    },
    moreText: {
      type: String,
      default: '更多'
    },
    iconMore: {
      type: String,
      default: ''
    },
    showMore: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  created () {},
  methods: {
    onMoreClick () {
      this.$emit('more')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/new-blue/variable.scss';
.iv-commont-title {
  width: 100%;
  overflow: hidden;
  border-bottom: 1px solid $iv-main-color;
  display: flex;
  align-items: center;
  .iconbox {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background-color: #005EBA;
    display: inline-flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    .iconfont {
      color: #fff;
    }
  }
  .iv-main-text {
    display: inline-flex;
    align-items: center;
  }
  .iv-main-title {
    font-size: 36px;
    font-family: 'STXinwei', cursive;
  }
  .iv-more-box {
    margin-left: auto;
  }
}
</style>